import React from 'react';

export const Analytics = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M2.59998 11.4315C2.59998 9.60313 4.53526 8.55949 5.8914 9.65648L10.0057 12.9846C10.5237 13.4036 10.8285 14.0612 10.8285 14.7595V29.1813C10.8285 30.4066 9.90753 31.4 8.7714 31.4H4.65712C3.52099 31.4 2.59998 30.4066 2.59998 29.1813V11.4315Z'
                fill='currentColor'
            />
            <path
                d='M12.8857 20.3064C12.8857 19.081 13.8067 18.0876 14.9428 18.0876H19.0571C20.1932 18.0876 21.1143 19.081 21.1143 20.3064V29.1812C21.1143 30.4066 20.1932 31.4 19.0571 31.4H14.9428C13.8067 31.4 12.8857 30.4066 12.8857 29.1813V20.3064Z'
                fill='currentColor'
            />
            <path
                d='M23.1714 4.82317C23.1714 2.81392 25.4498 1.8394 26.7266 3.30253L30.8408 8.01732C31.2 8.42889 31.4 8.97277 31.4 9.53795V29.1812C31.4 30.4066 30.479 31.4 29.3428 31.4H25.2285C24.0924 31.4 23.1714 30.4066 23.1714 29.1813V4.82317Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Analytics;
